import Marquee from "react-fast-marquee";

const ITEMS = [
  "SWING HARD",
  "RUN FAST",
  "BIG CAL",
  "#50",
  "HYPE FIRE ENERGY",
  "GAME DAY",
];

export default function KineticMarquee() {
  return (
    <div
      data-testid="kinetic-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#070709] py-6"
    >
      <Marquee speed={35} gradient={false}>
        {ITEMS.map((t, i) => (
          <span
            key={i}
            className="mx-10 whitespace-nowrap font-spray text-[9vw] leading-none md:text-[5vw]"
          >
            <span className={i % 2 === 0 ? "text-neon/85" : "text-neonpurple/85"}>
              {t}
            </span>
            <span className="mx-10 font-bebas text-hotpink">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
